import { ChangeDetectorRef, Component, Inject, OnDestroy, Optional, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CourseDisplayerService } from 'src/app/views/displayer/courses/course-displayer/course-displayer.service';
import { AppCalendarService } from 'src/app/views/event/app-calendar/app-calendar.service';
import { CreateEventComponent } from '../../../views/event/create-event/create-event.component';
import { AppConfirmService } from '../app-confirm/app-confirm.service';

@Component({
  selector: 'pop-content',
  templateUrl: './app-pop-content.component.html',
  styleUrls: ['./app-pop-content.compnonent.scss'],
  standalone: false,
})
export class AppPopContentComponent implements OnDestroy {
  @ViewChild('createEventModal', { static: false })
  createEventModal: CreateEventComponent;

  contentID;
  todoID;
  currentPage = 'content';
  data;
  event;
  constructor(
    @Optional() public dialogRef: MatDialogRef<AppPopContentComponent>,
    @Optional()
    public bottomSheetRef: MatBottomSheetRef<AppPopContentComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any,
    private confirmService: AppConfirmService,
    private calendarService: AppCalendarService,
    private router: Router,
    private cdService: CourseDisplayerService,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.data = this.dialogData || this.bottomSheetData;
    const data = this.data;
    if (!data.contentID) {
      this.currentPage = 'todoDetails';
    }
    this.contentID = data.contentID;
    this.todoID = data.todoID;
    this.event = data.event;

    // TODO supprimer cette façon de faire. L'interval n'est qu'un quickfix, il faut trouver une meilleur façon de faire
    // Le problème est qu'avec le bottomsheet les requetes asynchrone ne s'affiche une fois que la vue est rendu (rendered)
    // Il faut qu'une action se produise sur l'écran pour que le tout s'affiche dans le bottomsheet. Ce SetInterval est là pour déclencher
    // l'action. J'ai testé d'autres solution comme les output pour déclencher l'action, mais il faut attendre que le contenu soit complétement
    // rendered sur l'écran (ce qui est un évenement difficile à traquer)
    let intervalLoopCount = 0;
    const displayContentInterval = setInterval(() => {
      this.changeDetectorRef.markForCheck();
      intervalLoopCount++;
      if (intervalLoopCount > 10) {
        clearInterval(displayContentInterval);
      }
    }, 500);
  }

  ngOnDestroy() {
    // this.changeDetectorRef
  }

  goToThePage() {
    const content = this.data.content || this.data.event;
    if (content.courseID && content.type != 'course') {
      this.router.navigateByUrl(`/knowledge/displayer/${content.courseID}/${content.sectionID}/${content.lectureID}`);
    } else if (content.blogID) {
      this.router.navigateByUrl(`/articles/${content.blogID}`);
    } else if (content.type == 'course') {
      this.router.navigateByUrl(`/knowledge/displayer/${content.courseID}/${content.lastSectionID}/${content.lastLectureID}`);
    }
  }

  public deleteTodo() {
    this.confirmService
      .confirm({
        title: 'Delete Event?',
      })
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.calendarService.deleteEvent(this.todoID).subscribe((events) => {
          this.close();
        });
      });
  }

  onScroll(e) {
    this.cdService.passScrollEvent(e);
  }

  save() {
    this.createEventModal.editEvent();
    this.close();
  }

  close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
    }
  }
}
